module.exports = __webpack_public_path__ + "static/media/price_website.2cecfc43.png";